import classnames from "classnames";
import styles from "./styles/mosaic.module.scss";
import { useRouter } from "next/navigation";
import useModal from "hooks/useModal";
import PropTypes from "prop-types";

import { Box, Typography } from "@mui/material";
import { Flex, Image } from "ui";
import Preview from "./StoryPreview";

const StoryCard = ({ orientation, ...story }) => {
  const [open, { handleOpen, handleClose }] = useModal();
  const router = useRouter();

  const handleRead = (e) => {
    e.stopPropagation();
    router.push(`/library/${story._id}/`);
  };

  if (story.hidden) return null;

  return (
    <Box
      id={story._id}
      className={classnames(styles.story, {
        [styles[orientation]]: orientation,
      })}
      onClick={handleOpen}
    >
      <Box className={styles.cover}>
        <Image
          alt={story.name}
          blurDataURL={story.thumbs?.[orientation]}
          height={225}
          src={story.covers?.[orientation]}
          width={400}
        />
        <Flex className={styles.filter} hidden={story.builtWith !== "images"}>
          <Typography>{story.name}</Typography>
        </Flex>
      </Box>
      <Preview {...{ open, handleClose, handleRead, ...story }} />
    </Box>
  );
};

StoryCard.propTypes = {
  _id: PropTypes.string.isRequired,
  builtWith: PropTypes.string,
  covers: PropTypes.object,
  description: PropTypes.string,
  disabled: PropTypes.bool,
  file: PropTypes.string,
  hidden: PropTypes.bool,
  name: PropTypes.string,
  orientation: PropTypes.oneOf(["portrait", "landscape"]),
  thumbs: PropTypes.object,
  year: PropTypes.number,
};

export default StoryCard;
